import React from "react";
import { Swiper, SwiperSlide } from "components/swiper";
import { ReactComponent as LeftArrow } from "assets/svgs/left-arrow.svg";
import Image from "components/image";
import { formatTitle } from "helpers/format-title";

const settings = {
	loop: true,
	simulateTouch: true,
	mousewheel: {
		enabled: true,
		forceToAxis: true,
	},
	navigation: {
		enabled: true,
		nextEl: ".right-arrow-it",
		prevEl: ".left-arrow-it",
	},
	a11y: true,
};

const ImageTestimonials = ({ data }) => {
	const { title = "", image, testimonials } = data;

	return (
		<div className="w-full text-center">
			{title && <h1 className="hidden md:block my-5 md:my-10">{formatTitle(title)}</h1>}

			<div className="flex flex-col-reverse md:flex-row items-center px-5">
				<div className="w-full md:w-3/5">
					<p className="text-center text-[6.125em] font-[Baskerville]">&quot;</p>

					<Swiper className="m-auto" {...settings}>
						{testimonials.map((t) => {
							return (
								<SwiperSlide className="w-1/2 m-auto" key={t._key}>
									<div className="w-4/5 m-auto md:w-[55%]">
										<p className="italic text-center text-large"><em> {t.text} </em></p>
										<p className="text-center mt-3">{t.author}</p>
									</div>
								</SwiperSlide>
							);
						})}
						<div className="left-arrow-it">
							<LeftArrow className="w-2.5" role="presentation" aria-hidden="true" />
						</div>
						<div className="right-arrow-it">
							<LeftArrow className="w-2.5 rotate-180" role="presentation" aria-hidden="true" />
						</div>
					</Swiper>
				</div>
				<div className="w-full md:w-1/2">
					<Image className="md:w-[98%]" image={image} alt={image.alt} />
					{title && <h1 className="md:hidden mt-5">{formatTitle(title)}</h1>}
				</div>

			</div>
		</div>
	);

};

export default ImageTestimonials;